<template>
    <!-- 阅读理解 -->
    <div
        v-if="pageData.opusInfo && pageData.opusInfo.length && showModele"
        :class="['speech-box', pageData.courseTypeId === 13 ? 'mar-top' : '']"
    >
        <div class="title">
            阅读理解
        </div>
        <Swiper
            class="swiper"
            :autoplay="false"
            :loop="false"
            :allow-touch-move="false"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
        >
            <SwiperSlide
                v-for="(swiperItem, swiperIndex) in swiperData"
                :key="swiperIndex"
            >
                <div
                    style="width: 100%;
height: 100%;"
                >
                    <img
                        v-if="!isCanPlayAudio"
                        src="https://i.gsxcdn.com/2274080577_ggn54um8.png"
                        class="play-btn"
                        @click="handleClickPlayBtn"
                    >
                    <div
                        v-if="swiperItem.image.length > 1"
                        class="swiper-box"
                    >
                        <img
                            :src="swiperItem.image[0]"
                            class="swiper-image1"
                        >
                        <img
                            :src="swiperItem.image[1]"
                            class="swiper-image1"
                        >
                    </div>
                    <img
                        v-else
                        :src="swiperItem.image[0]"
                        class="swiper-image"
                    >
                </div>
            </SwiperSlide>
        </Swiper>
        <!-- 哈哈哈哈哈哈哈哈哈哈哈 -->
        <div class="pager">
            {{swiperData[currentSwiperIndex]?.txt}}
        </div>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';
import SwiperCore, {EffectCoverflow, Navigation} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/swiper.min.css';

SwiperCore.use([EffectCoverflow, Navigation]);

@Options({
    components: {
        Swiper,
        SwiperSlide,
    },
    mounted() {
        console.log(222222);
        const {opusInfo} = this.pageData;
        opusInfo && opusInfo.length && opusInfo.forEach(item => {
            item.image = item.image.split(',');
        });
        const data = opusInfo;
        this.swiperData = data;
        this.total = this.swiperData.length;
    },
    props: {
        pageData: {
            type: Object,
            default() {
                return {};
            }
        },
        showModele: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    watch: {
        showModele(val) {

            /**
             * 监听showModele来处理前后台切换，因为：
             * 将speech组件的v-if放在组件内部是要处理swiper组件的渲染问题，
             * 如果v-if放在外面的话speech组件会走完整的生命周期，导致swiper组件渲染失效，会有警告(Component is missing template or render function.)【未解】
             * 因此改变策略将v-if放在speech内部，那么speech的生命周期不会重新走，那么就要特殊处理语音播放问题
             */
            if (!val) {
                this.isCanPlayAudio = false;
                this.currentSwiperIndex = 0;
                this.audioEl?.pause();
            }
        }
    },
})
export default class Speech extends Vue {
    swiperData = [];

    total = 0;

    // 轮播图当前下图片的下标
    currentSwiperIndex = 0;

    // 用户是否点击了播放按钮
    isCanPlayAudio = false;

    audilNum = 0;

    // 音频节点
    audioEl = null;

    onSwiper(swiper) {
        console.log(swiper);
        this.swiper = swiper;
    }

    // 处理轮播图滑动
    onSlideChange() {
        this.currentSwiperIndex += 1;
        console.log('currentSwiperIndex=', this.currentSwiperIndex);
        if (this.isCanPlayAudio) {
            this.audilNum = 0;
            this.playSwiperTiganAudio(this.swiperData[this.currentSwiperIndex].questionAudio);
        }
    }

    // 播放轮播图题干音频
    playSwiperTiganAudio(url, cb) {
        this.audilNum += 1;
        if (this.audilNum > 2) {
            // 看下是否是最后一个了
            if (this.currentSwiperIndex + 1 === this.total) {
                this.isCanPlayAudio = false;
                this.currentSwiperIndex = 0;
                this.audilNum = 0;
                this.swiper.slideTo(0);
            }
            else {
                this.swiper.slideNext();
            }
            return;
        }
        this.playAudio(url).then(() => {
            // 在播放用户语音
            this.playSwiperTiganAudio(this.swiperData[this.currentSwiperIndex].url);
        });
    }

    // 点击播放按钮
    handleClickPlayBtn() {
        this.isCanPlayAudio = true;
        this.playSwiperTiganAudio(this.swiperData[this.currentSwiperIndex].questionAudio);
        // 捕获是否有正在播放的视频，有的话全部停掉
        const allVideos = document.querySelectorAll('.oss-work-video');
        const arr = [...allVideos];
        arr.forEach(item => {
            item.pause();
        });
    }

    // 播放语音
    playAudio(url) {
        console.log(' ------ playAudio ------', url);
        // 播放语音
        return new Promise(resolve => {
            if (!url) {
                resolve();
            }
            if (!this.audioEl) {
                const audio = new Audio();
                audio.onabort = () => {
                    console.log(
                        JSON.stringify({
                            content: 'playAudio onabort',
                            audioUrl: url,
                        })
                    );
                    console.log(`playAudio onabort ${url}`);
                };
                audio.onwaiting = () => {
                    console.log(
                        JSON.stringify({
                            content: 'playAudio onwaiting',
                            audioUrl: url,
                        })
                    );
                    console.log(`playAudio onwaiting ${url}`);
                };
                this.audioEl = audio;
            }
            this.audioEl.src = url;
            this.audioEl.currentTime = 0;
            this.audioEl.load();
            this.audioEl.onended = () => {
                console.log('playAudio onended', url);
                resolve();
            };
            this.audioEl.onpause = () => {
                console.log('playAudio onpause', url);
                resolve();
            };
            this.audioEl.onerror = error => {
                console.log(
                    JSON.stringify({
                        content: 'playAudio onerror',
                        audioUrl: url,
                        error: this.audioEl.error?.message,
                    })
                );
                console.log('playAudio onerror', url);
                console.log(this.audioEl.error?.message);
                resolve(error);
            };
            this.audioEl.play();
        });
    }
}
</script>

<style lang="scss" scoped>
.mar-top {
    margin-top: .4rem;
}
.speech-box {
    width: 8.51rem;
    height: 5.97rem;
    margin-bottom: .46rem;
    background: url("https://g.gsxcdn.com/2345253084_dqly3k23.png") 0 0 no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
        margin-top: .5rem;
        margin-bottom: .56rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .45rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
    }

    .swiper {
        width: 7.23rem;
        height: 3.12rem;
        position: relative;
    }

    .play-btn {
        width: 1.39rem;
        height: 1.39rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .swiper-image {
        width: 100%;
        height: 100%;
        border-radius: .21rem;
    }

    .swiper-box {
        width: 7.44rem;
        height: 3.33rem;
        background: #F7D9A6;
        border-radius: .11rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 .43rem;
        box-sizing: border-box;

        .swiper-image1 {
            width: 3.05rem;
            height: 2.29rem;
            border-radius: .11rem;
        }
    }

    .pager {
        width: 7.65rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: .4rem;
        color: #FFFFFF;
        line-height: .51rem;
        margin-top: .53rem;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>
